<template>
  <ul class="sort-button">
    <li class="sort-ascend" :class="{ 'sort-ascend-actived': ascended }" @click="handleAscend"></li>
    <li class="divider"></li>
    <li
      class="sort-descend"
      :class="{ 'sort-descend-actived': descended }"
      @click="handleDescend"
    ></li>
  </ul>
</template>

<script>
export default {
  props: {
    sortKey: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      ascended: false,
      descended: false,
    }
  },
  methods: {
    handleAscend() {
      if (this.descended) {
        this.descended = !this.descended
      }
      this.ascended = !this.ascended
      this.$emit("handleSort", { key: this.sortKey, flag: this.ascended ? 1 : 0 })
    },
    handleDescend() {
      if (this.ascended) {
        this.ascended = !this.ascended
      }
      this.descended = !this.descended
      this.$emit("handleSort", { key: this.sortKey, flag: this.descended ? -1 : 0 })
    },
  },
}
</script>

<style lang="scss" scoped>
$backgroundColor: #bbb;
$activedColor: #fff;
.sort-button {
  display: flex;
  flex-direction: column;
  margin-left: 5px;

  .sort-ascend,
  .sort-descend {
    border: 5px solid transparent;
    cursor: pointer;
  }
  .sort-ascend {
    border-bottom-color: $backgroundColor;
  }
  .divider {
    background-color: transparent;
    height: 4px;
  }
  .sort-descend {
    border-top-color: $backgroundColor;
  }
  .sort-ascend-actived {
    border-bottom-color: $activedColor;
  }
  .sort-descend-actived {
    border-top-color: $activedColor;
  }
}
</style>
